import * as types from '../actions/ActionTypes';

const INITIAL_STATE = {
  toasts: [],
  autohide: true,
  autohideTimeout: 5000
};

export function toastReducer(state = INITIAL_STATE, action) {

  switch (action.type) {
    case types.ADD_TOAST: {
      return {
        ...state,
        ...action.payload,
        toasts: state.toasts.concat(action.payload.toasts),
        autohide: action.payload.autohide || true,
        autohideTimeout: action.payload.autohideTimeout || 5000
      };
    }
    case types.DISMISS_TOAST:
      return {
        ...state,
        ...action.payload
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/toast.reducer.js